class KmlUtils {
  async extractGoogleCoords(plainText) {
    let parser = new DOMParser()
    let xmlDoc = parser.parseFromString(plainText, 'text/xml')
    let googlePolygons = []
    let googleMarkers = []

    if (xmlDoc.documentElement.nodeName == 'kml') {
      for (const item of xmlDoc.getElementsByTagName('Placemark')) {
        let placeMarkName = item.getElementsByTagName('name')[0].childNodes[0].nodeValue.trim()
        let polygons = item.getElementsByTagName('Polygon')
        let markers = item.getElementsByTagName('Point')

        /** POLYGONS PARSE **/
        for (const polygon of polygons) {
          let coords = polygon.getElementsByTagName('coordinates')[0].childNodes[0].nodeValue.trim()
          let points = coords.split(' ')

          let googlePolygonsPaths = []
          for (const point of points) {
            let coord = point.split(',')
            if (coord[0] && coord[1]) {
              //This condition check if any coordinate is null
              googlePolygonsPaths.push({ lat: +coord[1], lng: +coord[0] })
            }
          }
          googlePolygons.push(googlePolygonsPaths)
        }

        /** MARKER PARSE **/
        for (const marker of markers) {
          var coords = marker.getElementsByTagName('coordinates')[0].childNodes[0].nodeValue.trim()
          let coord = coords.split(',')
          googleMarkers.push({ lat: +coord[1], lng: +coord[0] })
        }
      }
    } else {
      throw 'error while parsing'
    }

    return { markers: googleMarkers, polygons: googlePolygons }
  }

  //compare if two polygons has the same coordinates
  //polygon has this shape -> [{lat: ##, lng: ##}]
  polygonsAreEqual(polygonA, polygonB) {
    if (!polygonA || !polygonB) {
      return false
    }

    if (polygonA.length === 0 || polygonB.length === 0) {
      return false
    }

    if (polygonA.length !== polygonB.length) {
      return false
    }

    let coincidences = 0
    for (let i of polygonA) {
      if (polygonB.some((j) => j.lat === i.lat && j.lng === i.lng)) {
        coincidences++
      }
    }
    if (coincidences === polygonA.length && coincidences === polygonB.length) {
      return true
    }

    return false
  }
}

export default KmlUtils



// WEBPACK FOOTER //
// ./src/utils/kml-utils.js